// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".s-canvas[data-v-693167a3]{margin-bottom:20px;overflow:hidden;border-radius:4px;height:40px;border:1px solid #06222c;width:90px;box-sizing:border-box;cursor:pointer;-webkit-tap-highlight-color:transparent}", ""]);
// Exports
module.exports = exports;
